import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';
import { CostanalysisdocumentDetails } from './costanalysisdocumentdetails';

@Injectable()
export class CostanalysisdocumentService {
    private _CostdocumentServiceReportUrl = CONFIGURATION.baseServiceUrl + 'documentnumbercostanalysisservicereport/';
    constructor(private _http: Http) { }

    getDocNumber(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostdocumentServiceReportUrl + 'getDocumentNumber', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getsource(data:any){
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostdocumentServiceReportUrl + 'getsource', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getProductionandCompany(docNumber: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostdocumentServiceReportUrl + 'getProductionAndCompany', docNumber,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getDocReportData(filterCriteria: any): Observable<CostanalysisdocumentDetails[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = 'getdocumentnumbercostanalysisReportData?DocumentNumber=' + filterCriteria.selectedDocnumber
            + '&Proudctioncompany=' + filterCriteria.selectedProductionShow + '&CompanyName=' + filterCriteria.selectedCompany;
        return this._http.get(this._CostdocumentServiceReportUrl + fileName, { headers: headers })
            .map((response: Response) => <CostanalysisdocumentDetails[]>response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostdocumentServiceReportUrl + 'excel-download', filterCriteria, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostdocumentServiceReportUrl + `v2/getdocumentnumbercostanalysisReportData`,data, { headers: headers })
          .map((res: Response) => res.json())
    }
}



// WEBPACK FOOTER //
// ./src/app/costanalysisdocumentnumber/costanalysisdocument.service.ts